import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './AdminRatesPage.css'
import * as actionTypes from '../../../store/actions';
import NumberFormat from 'react-number-format';
import AdminAuth from '../../../services/AdminAuth';
import * as actionCreators from '../../../store/actionCreators';
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";

export class AdminRatesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ip4_SandP500Risk: 100,
            ip4_SandPUSRetiree: 90,
            ip4_SandP500Annual: 7.5,
            ip4_iYRAnnual: 17,
            ip4_EFAAnnual: 10,
            ip5mva_SandP500Risk: 105,
            ip5mva_SandPUSRetiree: 95,
            ip5mva_SandP500Annual: 8,
            ip5mva_iYRAnnual: 17.5,
            ip5mva_EFAAnnual: 10.5,
            ip7_SandP500Risk: 110,
            ip7_SandPUSRetiree: 100,
            ip7_SandP500Annual: 8.5,
            ip7_iYRAnnual: 18,
            ip7_EFAAnnual: 11,
            ip5_SandP500Risk: 105,
            ip5_SandPUSRetiree: 95,
            ip5_SandP500Annual: 8,
            ip5_iYRAnnual: 17.5,
            ip5_EFAAnnual: 10.5,
            ia_sp500Minus10PercentageOver250K: 0,
            iaadvisory_sp500Minus10PercentageOver250K: 0,
            ia_sp500OneYear50PercentageOver250K: 0,
            iaadvisory_sp500OneYear50PercentageOver250K: 0,
            ia_sp500OneYear10PercentageOver250K: 0,
            iaadvisory_sp500OneYear10PercentageOver250K: 0,
            ia_sp500SixYear10PercentageOver250K: 0,
            iaadvisory_sp500SixYear10PercentageOver250K: 0,
            ia_eafeOneYear50PercenpageOver250K: 0,
            iaadvisory_eafeOneYear50PercenpageOver250K: 0,
            ia_eafeOneYear10PercenpageOver250K: 0,
            iaadvisory_eafeOneYear10PercenpageOver250K: 0,
            ia_realEstateOneYear50PercentageOver250K: 0,
            iaadvisory_realEstateOneYear50PercentageOver250K: 0,
            ia_realEstateOneYear10PercentageOver250K: 0,
            iaadvisory_realEstateOneYear10PercentageOver250K: 0,
            ia_spdrOneYear50PercentageOver250K: 0,
            iaadvisory_spdrOneYear50PercentageOver250K: 0,
            ia_spdrOneYear10PercentageOver250K: 0,
            iaadvisory_spdrOneYear10PercentageOver250K: 0,
            ia_sp500Minus10Percentage: 0,
            iaadvisory_sp500Minus10Percentage: 0,
            ia_sp500OneYear50Percentage: 0,
            iaadvisory_sp500OneYear50Percentage: 0,
            ia_sp500OneYear10Percentage: 0,
            iaadvisory_sp500OneYear10Percentage: 0,
            ia_sp500SixYear10Percentage: 0,
            iaadvisory_sp500SixYear10Percentage: 0,
            ia_eafeOneYear50Percenpage: 0,
            iaadvisory_eafeOneYear50Percenpage: 0,
            ia_eafeOneYear10Percenpage: 0,
            iaadvisory_eafeOneYear10Percenpage: 0,
            ia_realEstateOneYear50Percentage: 0,
            iaadvisory_realEstateOneYear50Percentage: 0,
            ia_realEstateOneYear10Percentage: 0,
            iaadvisory_realEstateOneYear10Percentage: 0,
            ia_spdrOneYear50Percentage: 0,
            iaadvisory_spdrOneYear50Percentage: 0,
            ia_spdrOneYear10Percentage: 0,
            iaadvisory_spdrOneYear10Percentage: 0,
            formErrors: {
                ip4_SandP500Risk: "",
                ip4_SandPUSRetiree: "",
                ip4_SandP500Annual: "",
                ip4_iYRAnnual: "",
                ip4_EFAAnnual: "",
                ip4_Barclay: "",
                ip5mva_SandP500Risk: "",
                ip5mva_SandPUSRetiree: "",
                ip5mva_SandP500Annual: "",
                ip5mva_iYRAnnual: "",
                ip5mva_EFAAnnual: "",
                ip5mva_Barclay: "",
                ip7_SandP500Risk: "",
                ip7_SandPUSRetiree: "",
                ip7_SandP500Annual: "",
                ip7_iYRAnnual: "",
                ip7_EFAAnnual: "",
                ip7_Barclay: "",
                ip5_SandP500Risk: "",
                ip5_SandPUSRetiree: "",
                ip5_SandP500Annual: "",
                ip5_iYRAnnual: "",
                ip5_EFAAnnual: "",
                ip5_Barclay: "",
                ia_sp500Minus10PercentageOver250K: "",
                iaadvisory_sp500Minus10PercentageOver250K: "",
                ia_sp500OneYear50PercentageOver250K: "",
                iaadvisory_sp500OneYear50PercentageOver250K: "",
                ia_sp500OneYear10PercentageOver250K: "",
                iaadvisory_sp500OneYear10PercentageOver250K: "",
                ia_sp500SixYear10PercentageOver250K: "",
                iaadvisory_sp500SixYear10PercentageOver250K: "",
                ia_eafeOneYear50PercenpageOver250K: "",
                iaadvisory_eafeOneYear50PercenpageOver250K: "",
                ia_eafeOneYear10PercenpageOver250K: "",
                iaadvisory_eafeOneYear10PercenpageOver250K: "",
                ia_realEstateOneYear50PercentageOver250K: "",
                iaadvisory_realEstateOneYear50PercentageOver250K: "",
                ia_realEstateOneYear10PercentageOver250K: "",
                iaadvisory_realEstateOneYear10PercentageOver250K: "",
                ia_spdrOneYear50PercentageOver250K: "",
                iaadvisory_spdrOneYear50PercentageOver250K: "",
                ia_spdrOneYear10PercentageOver250K: "",
                iaadvisory_spdrOneYear10PercentageOver250K: "",
                ia_sp500Minus10Percentage: "",
                iaadvisory_sp500Minus10Percentage: "",
                ia_sp500OneYear50Percentage: "",
                iaadvisory_sp500OneYear50Percentage: "",
                ia_sp500OneYear10Percentage: "",
                iaadvisory_sp500OneYear10Percentage: "",
                ia_sp500SixYear10Percentage: "",
                iaadvisory_sp500SixYear10Percentage: "",
                ia_eafeOneYear50Percenpage: "",
                iaadvisory_eafeOneYear50Percenpage: "",
                ia_eafeOneYear10Percenpage: "",
                iaadvisory_eafeOneYear10Percenpage: "",
                ia_realEstateOneYear50Percentage: "",
                iaadvisory_realEstateOneYear50Percentage: "",
                ia_realEstateOneYear10Percentage: "",
                iaadvisory_realEstateOneYear10Percentage: "",
                ia_spdrOneYear50Percentage: "",
                iaadvisory_spdrOneYear50Percentage: "",
                ia_spdrOneYear10Percentage: "",
                iaadvisory_spdrOneYear10Percentage: ""
            },
            fieldsValid: {
                ip4_SandP500RiskValid: true,
                ip4_SandPUSRetireeValid: true,
                ip4_SandP500AnnualValid: true,
                ip4_iYRAnnualValid: true,
                ip4_EFAAnnualValid: true,
                ip4_BarclayValid: true,
                ip5mva_SandP500RiskValid: true,
                ip5mva_SandPUSRetireeValid: true,
                ip5mva_SandP500AnnualValid: true,
                ip5mva_iYRAnnualValid: true,
                ip5mva_EFAAnnualValid: true,
                ip5mva_BarclayValid: true,
                ip7_SandP500RiskValid: true,
                ip7_SandPUSRetireeValid: true,
                ip7_SandP500AnnualValid: true,
                ip7_iYRAnnualValid: true,
                ip7_EFAAnnualValid: true,
                ip7_BarclayValid: true,
                ip5_SandP500RiskValid: true,
                ip5_SandPUSRetireeValid: true,
                ip5_SandP500AnnualValid: true,
                ip5_iYRAnnualValid: true,
                ip5_EFAAnnualValid: true,
                ip5_BarclayValid: true,
                ia_sp500Minus10PercentageOver250KValid: true,
                iaadvisory_sp500Minus10PercentageOver250KValid: true,
                ia_sp500OneYear50PercentageOver250KValid: true,
                iaadvisory_sp500OneYear50PercentageOver250KValid: true,
                ia_sp500OneYear10PercentageOver250KValid: true,
                iaadvisory_sp500OneYear10PercentageOver250KValid: true,
                ia_sp500SixYear10PercentageOver250KValid: true,
                iaadvisory_sp500SixYear10PercentageOver250KValid: true,
                ia_eafeOneYear50PercenpageOver250KValid: true,
                iaadvisory_eafeOneYear50PercenpageOver250KValid: true,
                ia_eafeOneYear10PercenpageOver250KValid: true,
                iaadvisory_eafeOneYear10PercenpageOver250KValid: true,
                ia_realEstateOneYear50PercentageOver250KValid: true,
                iaadvisory_realEstateOneYear50PercentageOver250KValid: true,
                ia_realEstateOneYear10PercentageOver250KValid: true,
                iaadvisory_realEstateOneYear10PercentageOver250KValid: true,
                ia_spdrOneYear50PercentageOver250KValid: true,
                iaadvisory_spdrOneYear50PercentageOver250KValid: true,
                ia_spdrOneYear10PercentageOver250KValid: true,
                iaadvisory_spdrOneYear10PercentageOver250KValid: true,
                ia_sp500Minus10PercentageValid: true,
                iaadvisory_sp500Minus10PercentageValid: true,
                ia_sp500OneYear50PercentageValid: true,
                iaadvisory_sp500OneYear50PercentageValid: true,
                ia_sp500OneYear10PercentageValid: true,
                iaadvisory_sp500OneYear10PercentageValid: true,
                ia_sp500SixYear10PercentageValid: true,
                iaadvisory_sp500SixYear10PercentageValid: true,
                ia_eafeOneYear50PercenpageValid: true,
                iaadvisory_eafeOneYear50PercenpageValid: true,
                ia_eafeOneYear10PercenpageValid: true,
                iaadvisory_eafeOneYear10PercenpageValid: true,
                ia_realEstateOneYear50PercentageValid: true,
                iaadvisory_realEstateOneYear50PercentageValid: true,
                ia_realEstateOneYear10PercentageValid: true,
                iaadvisory_realEstateOneYear10PercentageValid: true,
                ia_spdrOneYear50PercentageValid: true,
                iaadvisory_spdrOneYear50PercentageValid: true,
                ia_spdrOneYear10PercentageValid: true,
                iaadvisory_spdrOneYear10PercentageValid: true
            },
            formValid: true,
            submitted: false
        }

        this.props.adminPageSetSaved(false);
        this.props.getAdminProductsConfiguration();

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.logout = this.logout.bind(this);
        this.cancelClick = this.cancelClick.bind(this);

    }

    componentDidMount() {
        this.props.setAdminPage();
        if (this.props.updateMenuState) {
            this.props.updateMenuState();
        }
        if (AdminAuth.isAdminAuthenticated()) {
            this.props.adminSuccessfullyLoggedIn();
        }

    }

    componentWillReceiveProps(nextProps) {
        if (!AdminAuth.isAdminAuthenticated()) {
            this.props.history.push("/admin");
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.adminLoggedIn !== this.props.adminLoggedIn && !this.props.adminLoggedIn && !AdminAuth.isAdminAuthenticated()) {
            this.props.history.push("/admin");
        }
        if (prevProps.productReducer !== this.props.productReducer) {
            const ip4 = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP4";
            });
            const ip5mva = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP5 MVA";
            });
            const ip7 = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP7";
            });
            const ip5 = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP5";
            });
            const ia = this.props.productReducer.rilaData.find((element) => {
                return element.key === "INDEX ACHIEVER";
            });
            const iaadvisory = this.props.productReducer.rilaData.find((element) => {
                return element.key === "INDEX ACHIEVER ADVISORY";
            });

            this.setState({
                ip4_SandP500Risk: ip4.riskControl.value,
                ip4_SandPUSRetiree: ip4.retireeSpending.value,
                ip4_SandP500Annual: ip4.sp500.value,
                ip4_iYRAnnual: ip4.yir.value,
                ip4_EFAAnnual: ip4.efa.value,
                ip4_Barclay: 0,
                ip5mva_SandP500Risk: ip5mva.riskControl.value,
                ip5mva_SandPUSRetiree: ip5mva.retireeSpending.value,
                ip5mva_SandP500Annual: ip5mva.sp500.value,
                ip5mva_iYRAnnual: ip5mva.yir.value,
                ip5mva_EFAAnnual: ip5mva.efa.value,
                ip5mva_Barclay: ip5mva.barclay.value,

                ip7_SandP500Risk: ip7.riskControl.value,
                ip7_SandPUSRetiree: ip7.retireeSpending.value,
                ip7_SandP500Annual: ip7.sp500.value,
                ip7_iYRAnnual: ip7.yir.value,
                ip7_EFAAnnual: ip7.efa.value,
                ip7_Barclay: ip7.barclay.value,

                ip5_SandP500Risk: ip5.riskControl.value,
                ip5_SandPUSRetiree: ip5.retireeSpending.value,
                ip5_SandP500Annual: ip5.sp500.value,
                ip5_iYRAnnual: ip5.yir.value,
                ip5_EFAAnnual: ip5.efa.value,
                ip5_Barclay: ip5.barclay.value,

                ia_sp500Minus10PercentageOver250K: ia.sp500Minus10PercentageOver250K.value,
                iaadvisory_sp500Minus10PercentageOver250K: iaadvisory.sp500Minus10PercentageOver250K.value,
                ia_sp500OneYear50PercentageOver250K: ia.sp500OneYear50PercentageOver250K.value,
                iaadvisory_sp500OneYear50PercentageOver250K: iaadvisory.sp500OneYear50PercentageOver250K.value,
                ia_sp500OneYear10PercentageOver250K: ia.sp500OneYear10PercentageOver250K.value,
                iaadvisory_sp500OneYear10PercentageOver250K: iaadvisory.sp500OneYear10PercentageOver250K.value,
                ia_sp500SixYear10PercentageOver250K: ia.sp500SixYear10PercentageOver250K.value,
                iaadvisory_sp500SixYear10PercentageOver250K: iaadvisory.sp500SixYear10PercentageOver250K.value,
                ia_eafeOneYear50PercenpageOver250K: ia.eafeOneYear50PercenpageOver250K.value,
                iaadvisory_eafeOneYear50PercenpageOver250K: iaadvisory.eafeOneYear50PercenpageOver250K.value,
                ia_eafeOneYear10PercenpageOver250K: ia.eafeOneYear10PercenpageOver250K.value,
                iaadvisory_eafeOneYear10PercenpageOver250K: iaadvisory.eafeOneYear10PercenpageOver250K.value,
                ia_realEstateOneYear50PercentageOver250K: ia.realEstateOneYear50PercentageOver250K.value,
                iaadvisory_realEstateOneYear50PercentageOver250K: iaadvisory.realEstateOneYear50PercentageOver250K.value,
                ia_realEstateOneYear10PercentageOver250K: ia.realEstateOneYear10PercentageOver250K.value,
                iaadvisory_realEstateOneYear10PercentageOver250K: iaadvisory.realEstateOneYear10PercentageOver250K.value,
                ia_spdrOneYear50PercentageOver250K: ia.spdrOneYear50PercentageOver250K.value,
                iaadvisory_spdrOneYear50PercentageOver250K: iaadvisory.spdrOneYear50PercentageOver250K.value,
                ia_spdrOneYear10PercentageOver250K: ia.spdrOneYear10PercentageOver250K.value,
                iaadvisory_spdrOneYear10PercentageOver250K: iaadvisory.spdrOneYear10PercentageOver250K.value,
                ia_sp500Minus10Percentage: ia.sp500Minus10Percentage.value,
                iaadvisory_sp500Minus10Percentage: iaadvisory.sp500Minus10Percentage.value,
                ia_sp500OneYear50Percentage: ia.sp500OneYear50Percentage.value,
                iaadvisory_sp500OneYear50Percentage: iaadvisory.sp500OneYear50Percentage.value,
                ia_sp500OneYear10Percentage: ia.sp500OneYear10Percentage.value,
                iaadvisory_sp500OneYear10Percentage: iaadvisory.sp500OneYear10Percentage.value,
                ia_sp500SixYear10Percentage: ia.sp500SixYear10Percentage.value,
                iaadvisory_sp500SixYear10Percentage: iaadvisory.sp500SixYear10Percentage.value,
                ia_eafeOneYear50Percenpage: ia.eafeOneYear50Percenpage.value,
                iaadvisory_eafeOneYear50Percenpage: iaadvisory.eafeOneYear50Percenpage.value,
                ia_eafeOneYear10Percenpage: ia.eafeOneYear10Percenpage.value,
                iaadvisory_eafeOneYear10Percenpage: iaadvisory.eafeOneYear10Percenpage.value,
                ia_realEstateOneYear50Percentage: ia.realEstateOneYear50Percentage.value,
                iaadvisory_realEstateOneYear50Percentage: iaadvisory.realEstateOneYear50Percentage.value,
                ia_realEstateOneYear10Percentage: ia.realEstateOneYear10Percentage.value,
                iaadvisory_realEstateOneYear10Percentage: iaadvisory.realEstateOneYear10Percentage.value,
                ia_spdrOneYear50Percentage: ia.spdrOneYear50Percentage.value,
                iaadvisory_spdrOneYear50Percentage: iaadvisory.spdrOneYear50Percentage.value,
                ia_spdrOneYear10Percentage: ia.spdrOneYear10Percentage.value,
                iaadvisory_spdrOneYear10Percentage: iaadvisory.spdrOneYear10Percentage.value,

            });
        }

    }

    logout() {
        this.props.adminLogOut();
    }

    handleChange(e) {
        const { name, value } = e.target;
        const val = parseFloat(value.substring(0, value.length - 1));
        this.setState({ [name]: val }, () => { this.validateField(name, val) });
    }

    handleSubmit() {
        this.props.adminPageSetSaved(false);
        this.setState({ submitted: true });
        if (this.state.formValid) {
            const ip4 = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP4";
            });
            const ip5mva = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP5 MVA";
            });
            const ip7 = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP7";
            });
            const ip5 = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP5";
            });
            const ia = this.props.productReducer.rilaData.find((element) => {
                return element.key === "INDEX ACHIEVER";
            });
            const iaadvisory = this.props.productReducer.rilaData.find((element) => {
                return element.key === "INDEX ACHIEVER ADVISORY";
            });


            this.props.updateRates(
                {
                    "gaigProductType": "IP4",
                    "productAmountInfo": [
                        {
                            "portfolioAmount": null,
                            "productInfo": [
                                {
                                    "assetName": ip4.riskControl.assetName,
                                    "productRates": [
                                        {
                                            ...ip4.riskControl,
                                            value: this.state.ip4_SandP500Risk / 100
                                        },
                                        {
                                            ...ip4.retireeSpending,
                                            value: this.state.ip4_SandPUSRetiree / 100
                                        },
                                        {
                                            ...ip4.sp500,
                                            value: this.state.ip4_SandP500Annual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip4.yir.assetName,
                                    "productRates": [
                                        {
                                            ...ip4.yir,
                                            value: this.state.ip4_iYRAnnual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip4.efa.assetName,
                                    "productRates": [
                                        {
                                            ...ip4.efa,
                                            value: this.state.ip4_EFAAnnual / 100
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "gaigProductType": "IP5MVA",
                    "productAmountInfo": [
                        {
                            "portfolioAmount": null,
                            "productInfo": [
                                {
                                    "assetName": ip5mva.riskControl.assetName,
                                    "productRates": [
                                        {
                                            ...ip5mva.riskControl,
                                            value: this.state.ip5mva_SandP500Risk / 100
                                        },
                                        {
                                            ...ip5mva.retireeSpending,
                                            value: this.state.ip5mva_SandPUSRetiree / 100
                                        },
                                        {
                                            ...ip5mva.sp500,
                                            value: this.state.ip5mva_SandP500Annual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip5mva.yir.assetName,
                                    "productRates": [
                                        {
                                            ...ip5mva.yir,
                                            value: this.state.ip5mva_iYRAnnual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip5mva.efa.assetName,
                                    "productRates": [
                                        {
                                            ...ip5mva.efa,
                                            value: this.state.ip5mva_EFAAnnual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip5mva.barclay.assetName,
                                    "productRates": [
                                        {
                                            ...ip5mva.barclay,
                                            value: this.state.ip5mva_Barclay / 100
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "gaigProductType": "IP7",
                    "productAmountInfo": [
                        {
                            "portfolioAmount": null,
                            "productInfo": [
                                {
                                    "assetName": ip7.riskControl.assetName,
                                    "productRates": [
                                        {
                                            ...ip7.riskControl,
                                            value: this.state.ip7_SandP500Risk / 100
                                        },
                                        {
                                            ...ip7.retireeSpending,
                                            value: this.state.ip7_SandPUSRetiree / 100
                                        },
                                        {
                                            ...ip7.sp500,
                                            value: this.state.ip7_SandP500Annual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip7.yir.assetName,
                                    "productRates": [
                                        {
                                            ...ip7.yir,
                                            value: this.state.ip7_iYRAnnual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip7.efa.assetName,
                                    "productRates": [
                                        {
                                            ...ip7.efa,
                                            value: this.state.ip7_EFAAnnual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip7.barclay.assetName,
                                    "productRates": [
                                        {
                                            ...ip7.barclay,
                                            value: this.state.ip7_Barclay / 100
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "gaigProductType": "IP5",
                    "productAmountInfo": [
                        {
                            "portfolioAmount": null,
                            "productInfo": [
                                {
                                    "assetName": ip5.riskControl.assetName,
                                    "productRates": [
                                        {
                                            ...ip5.riskControl,
                                            value: this.state.ip5_SandP500Risk / 100
                                        },
                                        {
                                            ...ip5.retireeSpending,
                                            value: this.state.ip5_SandPUSRetiree / 100
                                        },
                                        {
                                            ...ip5.sp500,
                                            value: this.state.ip5_SandP500Annual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip5.yir.assetName,
                                    "productRates": [
                                        {
                                            ...ip5.yir,
                                            value: this.state.ip5_iYRAnnual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip5.efa.assetName,
                                    "productRates": [
                                        {
                                            ...ip5.efa,
                                            value: this.state.ip5_EFAAnnual / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ip5.barclay.assetName,
                                    "productRates": [
                                        {
                                            ...ip5.barclay,
                                            value: this.state.ip5_Barclay / 100
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "gaigProductType": "INDEX_ACHIEVER",
                    "productAmountInfo": [
                        {
                            "portfolioAmount": 250001.0,
                            "productInfo": [
                                {
                                    "assetName": ia.sp500Minus10PercentageOver250K.assetName,
                                    "productRates": [
                                        {
                                            ...ia.sp500Minus10PercentageOver250K,
                                            value: this.state.ia_sp500Minus10PercentageOver250K / 100
                                        },
                                        {
                                            ...ia.sp500OneYear10PercentageOver250K,
                                            value: this.state.ia_sp500OneYear10PercentageOver250K / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ia.eafeOneYear10PercenpageOver250K.assetName,
                                    "productRates": [
                                        {
                                            ...ia.eafeOneYear10PercenpageOver250K,
                                            value: this.state.ia_eafeOneYear10PercenpageOver250K / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ia.realEstateOneYear10PercentageOver250K.assetName,
                                    "productRates": [
                                        {
                                            ...ia.realEstateOneYear10PercentageOver250K,
                                            value: this.state.ia_realEstateOneYear10PercentageOver250K / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ia.spdrOneYear10PercentageOver250K.assetName,
                                    "productRates": [
                                        {
                                            ...ia.spdrOneYear10PercentageOver250K,
                                            value: this.state.ia_spdrOneYear10PercentageOver250K / 100
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "portfolioAmount": 250000.0,
                            "productInfo": [
                                {
                                    "assetName": ia.sp500Minus10Percentage.assetName,
                                    "productRates": [
                                        {
                                            ...ia.sp500Minus10Percentage,
                                            value: this.state.ia_sp500Minus10Percentage / 100
                                        },
                                        {
                                            ...ia.sp500OneYear10Percentage,
                                            value: this.state.ia_sp500OneYear10Percentage / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ia.eafeOneYear10Percenpage.assetName,
                                    "productRates": [
                                        {
                                            ...ia.eafeOneYear10Percenpage,
                                            value: this.state.ia_eafeOneYear10Percenpage / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ia.realEstateOneYear10Percentage.assetName,
                                    "productRates": [
                                        {
                                            ...ia.realEstateOneYear10Percentage,
                                            value: this.state.ia_realEstateOneYear10Percentage / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": ia.spdrOneYear10Percentage.assetName,
                                    "productRates": [
                                        {
                                            ...ia.spdrOneYear10Percentage,
                                            value: this.state.ia_spdrOneYear10Percentage / 100
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "gaigProductType": "INDEX_ACHIEVER_ADVISORY",
                    "productAmountInfo": [
                        {
                            "portfolioAmount": 250001.0,
                            "productInfo": [
                                {
                                    "assetName": iaadvisory.sp500Minus10PercentageOver250K.assetName,
                                    "productRates": [
                                        {
                                            ...iaadvisory.sp500Minus10PercentageOver250K,
                                            value: this.state.iaadvisory_sp500Minus10PercentageOver250K / 100
                                        },
                                        {
                                            ...iaadvisory.sp500OneYear10PercentageOver250K,
                                            value: this.state.iaadvisory_sp500OneYear10PercentageOver250K / 100
                                        },
                                        {
                                            ...iaadvisory.sp500OneYear50PercentageOver250K,
                                            value: this.state.iaadvisory_sp500OneYear50PercentageOver250K / 100
                                        },
                                        {
                                            ...iaadvisory.sp500SixYear10PercentageOver250K,
                                            value: this.state.iaadvisory_sp500SixYear10PercentageOver250K / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": iaadvisory.eafeOneYear50PercenpageOver250K.assetName,
                                    "productRates": [
                                        {
                                            ...iaadvisory.eafeOneYear50PercenpageOver250K,
                                            value: this.state.iaadvisory_eafeOneYear50PercenpageOver250K / 100
                                        },
                                        {
                                            ...iaadvisory.eafeOneYear10PercenpageOver250K,
                                            value: this.state.iaadvisory_eafeOneYear10PercenpageOver250K / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": iaadvisory.realEstateOneYear50PercentageOver250K.assetName,
                                    "productRates": [
                                        {
                                            ...iaadvisory.realEstateOneYear50PercentageOver250K,
                                            value: this.state.iaadvisory_realEstateOneYear50PercentageOver250K / 100
                                        },
                                        {
                                            ...iaadvisory.realEstateOneYear10PercentageOver250K,
                                            value: this.state.iaadvisory_realEstateOneYear10PercentageOver250K / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": iaadvisory.spdrOneYear50PercentageOver250K.assetName,
                                    "productRates": [
                                        {
                                            ...iaadvisory.spdrOneYear50PercentageOver250K,
                                            value: this.state.iaadvisory_spdrOneYear50PercentageOver250K / 100
                                        },
                                        {
                                            ...iaadvisory.spdrOneYear10PercentageOver250K,
                                            value: this.state.iaadvisory_spdrOneYear10PercentageOver250K / 100
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "portfolioAmount": 250000.0,
                            "productInfo": [
                                {
                                    "assetName": iaadvisory.sp500Minus10Percentage.assetName,
                                    "productRates": [
                                        {
                                            ...iaadvisory.sp500Minus10Percentage,
                                            value: this.state.iaadvisory_sp500Minus10Percentage / 100
                                        },
                                        {
                                            ...iaadvisory.sp500OneYear10Percentage,
                                            value: this.state.iaadvisory_sp500OneYear10Percentage / 100
                                        },
                                        {
                                            ...iaadvisory.sp500OneYear50Percentage,
                                            value: this.state.iaadvisory_sp500OneYear50Percentage / 100
                                        },
                                        {
                                            ...iaadvisory.sp500SixYear10Percentage,
                                            value: this.state.iaadvisory_sp500SixYear10Percentage / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": iaadvisory.eafeOneYear50Percenpage.assetName,
                                    "productRates": [
                                        {
                                            ...iaadvisory.eafeOneYear50Percenpage,
                                            value: this.state.iaadvisory_eafeOneYear50Percenpage / 100
                                        },
                                        {
                                            ...iaadvisory.eafeOneYear10Percenpage,
                                            value: this.state.iaadvisory_eafeOneYear10Percenpage / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": iaadvisory.realEstateOneYear50Percentage.assetName,
                                    "productRates": [
                                        {
                                            ...iaadvisory.realEstateOneYear50Percentage,
                                            value: this.state.iaadvisory_realEstateOneYear50Percentage / 100
                                        },
                                        {
                                            ...iaadvisory.realEstateOneYear10Percentage,
                                            value: this.state.iaadvisory_realEstateOneYear10Percentage / 100
                                        }
                                    ]
                                },
                                {
                                    "assetName": iaadvisory.spdrOneYear50Percentage.assetName,
                                    "productRates": [
                                        {
                                            ...iaadvisory.spdrOneYear50Percentage,
                                            value: this.state.iaadvisory_spdrOneYear50Percentage / 100
                                        },
                                        {
                                            ...iaadvisory.spdrOneYear10Percentage,
                                            value: this.state.iaadvisory_spdrOneYear10Percentage / 100
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            );
        }
    }

    cancelClick() {
        const ip4 = this.props.productReducer.productsData.find((element) => {
            return element.key === "IP4";
        });
        const ip5mva = this.props.productReducer.productsData.find((element) => {
            return element.key === "IP5 MVA";
        });
        const ip7 = this.props.productReducer.productsData.find((element) => {
            return element.key === "IP7";
        });
        const ip5 = this.props.productReducer.productsData.find((element) => {
            return element.key === "IP5";
        });
        const ia = this.props.productReducer.rilaData.find((element) => {
            return element.key === "INDEX ACHIEVER";
        });
        const iaadvisory = this.props.productReducer.rilaData.find((element) => {
            return element.key === "INDEX ACHIEVER ADVISORY";
        });
        this.setState({
            ip4_SandP500Risk: ip4.riskControl.value,
            ip4_SandPUSRetiree: ip4.retireeSpending.value,
            ip4_SandP500Annual: ip4.sp500.value,
            ip4_iYRAnnual: ip4.yir.value,
            ip4_EFAAnnual: ip4.efa.value,
            ip5mva_SandP500Risk: ip5mva.riskControl.value,
            ip5mva_SandPUSRetiree: ip5mva.retireeSpending.value,
            ip5mva_SandP500Annual: ip5mva.sp500.value,
            ip5mva_iYRAnnual: ip5mva.yir.value,
            ip5mva_EFAAnnual: ip5mva.efa.value,
            ip7_SandP500Risk: ip7.riskControl.value,
            ip7_SandPUSRetiree: ip7.retireeSpending.value,
            ip7_SandP500Annual: ip7.sp500.value,
            ip7_iYRAnnual: ip7.yir.value,
            ip7_EFAAnnual: ip7.efa.value,
            ip5_SandP500Risk: ip5.riskControl.value,
            ip5_SandPUSRetiree: ip5.retireeSpending.value,
            ip5_SandP500Annual: ip5.sp500.value,
            ip5_iYRAnnual: ip5.yir.value,
            ip5_EFAAnnual: ip5.efa.value,
            ia_sp500Minus10PercentageOver250K: ia.sp500Minus10PercentageOver250K.value,
            iaadvisory_sp500Minus10PercentageOver250K: iaadvisory.sp500Minus10PercentageOver250K.value,
            ia_sp500OneYear50PercentageOver250K: ia.sp500OneYear50PercentageOver250K.value,
            iaadvisory_sp500OneYear50PercentageOver250K: iaadvisory.sp500OneYear50PercentageOver250K.value,
            ia_sp500OneYear10PercentageOver250K: ia.sp500OneYear10PercentageOver250K.value,
            iaadvisory_sp500OneYear10PercentageOver250K: iaadvisory.sp500OneYear10PercentageOver250K.value,
            ia_sp500SixYear10PercentageOver250K: ia.sp500SixYear10PercentageOver250K.value,
            iaadvisory_sp500SixYear10PercentageOver250K: iaadvisory.sp500SixYear10PercentageOver250K.value,
            ia_eafeOneYear50PercenpageOver250K: ia.eafeOneYear50PercenpageOver250K.value,
            iaadvisory_eafeOneYear50PercenpageOver250K: iaadvisory.eafeOneYear50PercenpageOver250K.value,
            ia_eafeOneYear10PercenpageOver250K: ia.eafeOneYear10PercenpageOver250K.value,
            iaadvisory_eafeOneYear10PercenpageOver250K: iaadvisory.eafeOneYear10PercenpageOver250K.value,
            ia_realEstateOneYear50PercentageOver250K: ia.realEstateOneYear50PercentageOver250K.value,
            iaadvisory_realEstateOneYear50PercentageOver250K: iaadvisory.realEstateOneYear50PercentageOver250K.value,
            ia_realEstateOneYear10PercentageOver250K: ia.realEstateOneYear10PercentageOver250K.value,
            iaadvisory_realEstateOneYear10PercentageOver250K: iaadvisory.realEstateOneYear10PercentageOver250K.value,
            ia_spdrOneYear50PercentageOver250K: ia.spdrOneYear50PercentageOver250K.value,
            iaadvisory_spdrOneYear50PercentageOver250K: iaadvisory.spdrOneYear50PercentageOver250K.value,
            ia_spdrOneYear10PercentageOver250K: ia.spdrOneYear10PercentageOver250K.value,
            iaadvisory_spdrOneYear10PercentageOver250K: iaadvisory.spdrOneYear10PercentageOver250K.value,
            ia_sp500Minus10Percentage: ia.sp500Minus10Percentage.value,
            iaadvisory_sp500Minus10Percentage: iaadvisory.sp500Minus10Percentage.value,
            ia_sp500OneYear50Percentage: ia.sp500OneYear50Percentage.value,
            iaadvisory_sp500OneYear50Percentage: iaadvisory.sp500OneYear50Percentage.value,
            ia_sp500OneYear10Percentage: ia.sp500OneYear10Percentage.value,
            iaadvisory_sp500OneYear10Percentage: iaadvisory.sp500OneYear10Percentage.value,
            ia_sp500SixYear10Percentage: ia.sp500SixYear10Percentage.value,
            iaadvisory_sp500SixYear10Percentage: iaadvisory.sp500SixYear10Percentage.value,
            ia_eafeOneYear50Percenpage: ia.eafeOneYear50Percenpage.value,
            iaadvisory_eafeOneYear50Percenpage: iaadvisory.eafeOneYear50Percenpage.value,
            ia_eafeOneYear10Percenpage: ia.eafeOneYear10Percenpage.value,
            iaadvisory_eafeOneYear10Percenpage: iaadvisory.eafeOneYear10Percenpage.value,
            ia_realEstateOneYear50Percentage: ia.realEstateOneYear50Percentage.value,
            iaadvisory_realEstateOneYear50Percentage: iaadvisory.realEstateOneYear50Percentage.value,
            ia_realEstateOneYear10Percentage: ia.realEstateOneYear10Percentage.value,
            iaadvisory_realEstateOneYear10Percentage: iaadvisory.realEstateOneYear10Percentage.value,
            ia_spdrOneYear50Percentage: ia.spdrOneYear50Percentage.value,
            iaadvisory_spdrOneYear50Percentage: iaadvisory.spdrOneYear50Percentage.value,
            ia_spdrOneYear10Percentage: ia.spdrOneYear10Percentage.value,
            iaadvisory_spdrOneYear10Percentage: iaadvisory.spdrOneYear10Percentage.value,
            fieldsValid: {
                ip4_SandP500RiskValid: true,
                ip4_SandPUSRetireeValid: true,
                ip4_SandP500AnnualValid: true,
                ip4_iYRAnnualValid: true,
                ip4_EFAAnnualValid: true,
                ip5mva_SandP500RiskValid: true,
                ip5mva_SandPUSRetireeValid: true,
                ip5mva_SandP500AnnualValid: true,
                ip5mva_iYRAnnualValid: true,
                ip5mva_EFAAnnualValid: true,
                ip7_SandP500RiskValid: true,
                ip7_SandPUSRetireeValid: true,
                ip7_SandP500AnnualValid: true,
                ip7_iYRAnnualValid: true,
                ip7_EFAAnnualValid: true,
                ip5_SandP500RiskValid: true,
                ip5_SandPUSRetireeValid: true,
                ip5_SandP500AnnualValid: true,
                ip5_iYRAnnualValid: true,
                ip5_EFAAnnualValid: true,
                ia_sp500Minus10PercentageOver250KValid: true,
                iaadvisory_sp500Minus10PercentageOver250KValid: true,
                ia_sp500OneYear50PercentageOver250KValid: true,
                iaadvisory_sp500OneYear50PercentageOver250KValid: true,
                ia_sp500OneYear10PercentageOver250KValid: true,
                iaadvisory_sp500OneYear10PercentageOver250KValid: true,
                ia_sp500SixYear10PercentageOver250KValid: true,
                iaadvisory_sp500SixYear10PercentageOver250KValid: true,
                ia_eafeOneYear50PercenpageOver250KValid: true,
                iaadvisory_eafeOneYear50PercenpageOver250KValid: true,
                ia_eafeOneYear10PercenpageOver250KValid: true,
                iaadvisory_eafeOneYear10PercenpageOver250KValid: true,
                ia_realEstateOneYear50PercentageOver250KValid: true,
                iaadvisory_realEstateOneYear50PercentageOver250KValid: true,
                ia_realEstateOneYear10PercentageOver250KValid: true,
                iaadvisory_realEstateOneYear10PercentageOver250KValid: true,
                ia_spdrOneYear50PercentageOver250KValid: true,
                iaadvisory_spdrOneYear50PercentageOver250KValid: true,
                ia_spdrOneYear10PercentageOver250KValid: true,
                iaadvisory_spdrOneYear10PercentageOver250KValid: true,
                ia_sp500Minus10PercentageValid: true,
                iaadvisory_sp500Minus10PercentageValid: true,
                ia_sp500OneYear50PercentageValid: true,
                iaadvisory_sp500OneYear50PercentageValid: true,
                ia_sp500OneYear10PercentageValid: true,
                iaadvisory_sp500OneYear10PercentageValid: true,
                ia_sp500SixYear10PercentageValid: true,
                iaadvisory_sp500SixYear10PercentageValid: true,
                ia_eafeOneYear50PercenpageValid: true,
                iaadvisory_eafeOneYear50PercenpageValid: true,
                ia_eafeOneYear10PercenpageValid: true,
                iaadvisory_eafeOneYear10PercenpageValid: true,
                ia_realEstateOneYear50PercentageValid: true,
                iaadvisory_realEstateOneYear50PercentageValid: true,
                ia_realEstateOneYear10PercentageValid: true,
                iaadvisory_realEstateOneYear10PercentageValid: true,
                ia_spdrOneYear50PercentageValid: true,
                iaadvisory_spdrOneYear50PercentageValid: true,
                ia_spdrOneYear10PercentageValid: true,
                iaadvisory_spdrOneYear10PercentageValid: true
            },
            formValid: true,
        })
    }

    validateField(fieldName, value) {
        // const val = parseFloat(value.substring(0, value.length - 1));
        const val = value;
        let fieldsValid = this.state.fieldsValid;
        let fieldValidationErrors = this.state.formErrors;
        let fieldValid = false;

        switch (fieldName) {
            case "ip4_SandP500Risk":
            case "ip4_SandPUSRetiree":
            case "ip5mva_SandP500Risk":
            case "ip5mva_SandPUSRetiree":
            case "ip7_SandP500Risk":
            case "ip7_SandPUSRetiree":
            case "ip5_SandP500Risk":
            case "ip5_SandPUSRetiree":
                fieldValid = val >= 0 && val <= 250;
                fieldsValid[fieldName + "Valid"] = fieldValid;
                fieldValidationErrors[fieldName] = fieldValid ? "" : ' should be between 0% and 250%';
                break;
            case "ip4_SandP500Annual":
            case "ip4_iYRAnnual":
            case "ip4_EFAAnnual":
            case "ip5mva_SandP500Annual":
            case "ip5mva_iYRAnnual":
            case "ip5mva_EFAAnnual":
            case "ip7_SandP500Annual":
            case "ip7_iYRAnnual":
            case "ip7_EFAAnnual":
            case "ip5_SandP500Annual":
            case "ip5_iYRAnnual":
            case "ip5_EFAAnnual":
                fieldValid = val >= 0 && val <= 50;
                fieldsValid[fieldName + "Valid"] = fieldValid;
                fieldValidationErrors[fieldName] = fieldValid ? "" : ' should be between 0% and 50%';
                break;
            case "ia_sp500Minus10PercentageOver250K":
            case "ia_sp500Minus10Percentage":
            case "iaadvisory_sp500Minus10PercentageOver250K":
            case "iaadvisory_sp500Minus10Percentage":
            case "ia_sp500OneYear10PercentageOver250K":
            case "ia_sp500OneYear10Percentage":
            case "iaadvisory_sp500OneYear10PercentageOver250K":
            case "iaadvisory_sp500OneYear10Percentage":
            case "ia_eafeOneYear10PercenpageOver250K":
            case "ia_eafeOneYear10Percenpage":
            case "iaadvisory_eafeOneYear10PercenpageOver250K":
            case "iaadvisory_eafeOneYear10Percenpage":
            case "ia_realEstateOneYear10PercentageOver250K":
            case "ia_realEstateOneYear10Percentage":
            case "iaadvisory_realEstateOneYear10PercentageOver250K":
            case "iaadvisory_realEstateOneYear10Percentage":
            case "ia_spdrOneYear10PercentageOver250K":
            case "ia_spdrOneYear10Percentage":
            case "iaadvisory_spdrOneYear10PercentageOver250K":
            case "iaadvisory_spdrOneYear10Percentage":
                fieldValid = val >= 0 && val <= 100;
                fieldsValid[fieldName + "Valid"] = fieldValid;
                fieldValidationErrors[fieldName] = fieldValid ? "" : ' should be between 0% and 100%';
                break;
            case "ia_sp500OneYear50PercentageOver250K":
            case "ia_sp500SixYear10PercentageOver250K":
            case "ia_eafeOneYear50PercenpageOver250K":
            case "ia_spdrOneYear50PercentageOver250K":
            case "ia_realEstateOneYear50PercentageOver250K":
            case "ia_sp500OneYear50Percentage":
            case "ia_sp500SixYear10Percentage":
            case "ia_eafeOneYear50Percenpage":
            case "ia_realEstateOneYear50Percentage":
            case "ia_spdrOneYear50Percentage":
            case "iaadvisory_sp500OneYear50PercentageOver250K":
            case "iaadvisory_sp500SixYear10PercentageOver250K":
            case "iaadvisory_eafeOneYear50PercenpageOver250K":
            case "iaadvisory_realEstateOneYear50PercentageOver250K":
            case "iaadvisory_spdrOneYear50PercentageOver250K":
            case "iaadvisory_sp500OneYear50Percentage":
            case "iaadvisory_sp500SixYear10Percentage":
            case "iaadvisory_eafeOneYear50Percenpage":
            case "iaadvisory_realEstateOneYear50Percentage":
            case "iaadvisory_spdrOneYear50Percentage":
                fieldValid = val >= 0 && val <= 250;
                fieldsValid[fieldName + "Valid"] = fieldValid;
                fieldValidationErrors[fieldName] = fieldValid ? "" : ' should be between 0% and 250%';
                break;
            default:
                break;
        }

        this.setState({
            formErrors: fieldValidationErrors,
            fieldsValid: fieldsValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({
            formValid:
                this.state.fieldsValid.ip4_SandP500RiskValid &&
                this.state.fieldsValid.ip4_SandPUSRetireeValid &&
                this.state.fieldsValid.ip4_SandP500AnnualValid &&
                this.state.fieldsValid.ip4_iYRAnnualValid &&
                this.state.fieldsValid.ip4_EFAAnnualValid &&
                this.state.fieldsValid.ip5mva_SandP500RiskValid &&
                this.state.fieldsValid.ip5mva_SandPUSRetireeValid &&
                this.state.fieldsValid.ip5mva_SandP500AnnualValid &&
                this.state.fieldsValid.ip5mva_iYRAnnualValid &&
                this.state.fieldsValid.ip5mva_EFAAnnualValid &&
                this.state.fieldsValid.ip7_SandP500RiskValid &&
                this.state.fieldsValid.ip7_SandPUSRetireeValid &&
                this.state.fieldsValid.ip7_SandP500AnnualValid &&
                this.state.fieldsValid.ip7_iYRAnnualValid &&
                this.state.fieldsValid.ip7_EFAAnnualValid &&
                this.state.fieldsValid.ip5_SandP500RiskValid &&
                this.state.fieldsValid.ip5_SandPUSRetireeValid &&
                this.state.fieldsValid.ip5_SandP500AnnualValid &&
                this.state.fieldsValid.ip5_iYRAnnualValid &&
                this.state.fieldsValid.ip5_EFAAnnualValid &&
                this.state.fieldsValid.ia_sp500Minus10PercentageOver250KValid &&
                this.state.fieldsValid.iaadvisory_sp500Minus10PercentageOver250KValid &&
                this.state.fieldsValid.ia_sp500OneYear50PercentageOver250KValid &&
                this.state.fieldsValid.iaadvisory_sp500OneYear50PercentageOver250KValid &&
                this.state.fieldsValid.ia_sp500OneYear10PercentageOver250KValid &&
                this.state.fieldsValid.iaadvisory_sp500OneYear10PercentageOver250KValid &&
                this.state.fieldsValid.ia_sp500SixYear10PercentageOver250KValid &&
                this.state.fieldsValid.iaadvisory_sp500SixYear10PercentageOver250KValid &&
                this.state.fieldsValid.ia_eafeOneYear50PercenpageOver250KValid &&
                this.state.fieldsValid.iaadvisory_eafeOneYear50PercenpageOver250KValid &&
                this.state.fieldsValid.ia_eafeOneYear10PercenpageOver250KValid &&
                this.state.fieldsValid.iaadvisory_eafeOneYear10PercenpageOver250KValid &&
                this.state.fieldsValid.ia_realEstateOneYear50PercentageOver250KValid &&
                this.state.fieldsValid.iaadvisory_realEstateOneYear50PercentageOver250KValid &&
                this.state.fieldsValid.ia_realEstateOneYear10PercentageOver250KValid &&
                this.state.fieldsValid.iaadvisory_realEstateOneYear10PercentageOver250KValid &&
                this.state.fieldsValid.ia_spdrOneYear50PercentageOver250KValid &&
                this.state.fieldsValid.iaadvisory_spdrOneYear50PercentageOver250KValid &&
                this.state.fieldsValid.ia_spdrOneYear10PercentageOver250KValid &&
                this.state.fieldsValid.iaadvisory_spdrOneYear10PercentageOver250KValid &&
                this.state.fieldsValid.ia_sp500Minus10PercentageValid &&
                this.state.fieldsValid.iaadvisory_sp500Minus10PercentageValid &&
                this.state.fieldsValid.ia_sp500OneYear50PercentageValid &&
                this.state.fieldsValid.iaadvisory_sp500OneYear50PercentageValid &&
                this.state.fieldsValid.ia_sp500OneYear10PercentageValid &&
                this.state.fieldsValid.iaadvisory_sp500OneYear10PercentageValid &&
                this.state.fieldsValid.ia_sp500SixYear10PercentageValid &&
                this.state.fieldsValid.iaadvisory_sp500SixYear10PercentageValid &&
                this.state.fieldsValid.ia_eafeOneYear50PercenpageValid &&
                this.state.fieldsValid.iaadvisory_eafeOneYear50PercenpageValid &&
                this.state.fieldsValid.ia_eafeOneYear10PercenpageValid &&
                this.state.fieldsValid.iaadvisory_eafeOneYear10PercenpageValid &&
                this.state.fieldsValid.ia_realEstateOneYear50PercentageValid &&
                this.state.fieldsValid.iaadvisory_realEstateOneYear50PercentageValid &&
                this.state.fieldsValid.ia_realEstateOneYear10PercentageValid &&
                this.state.fieldsValid.iaadvisory_realEstateOneYear10PercentageValid &&
                this.state.fieldsValid.ia_spdrOneYear50PercentageValid &&
                this.state.fieldsValid.iaadvisory_spdrOneYear50PercentageValid &&
                this.state.fieldsValid.ia_spdrOneYear10PercentageValid &&
                this.state.fieldsValid.iaadvisory_spdrOneYear10PercentageValid
        });
    }

    render() {
        const {
            ip4_SandP500Risk,
            ip4_SandPUSRetiree,
            ip4_SandP500Annual,
            ip4_iYRAnnual,
            ip4_EFAAnnual,
            ip4_Barclay,
            ip5mva_SandP500Risk,
            ip5mva_SandPUSRetiree,
            ip5mva_SandP500Annual,
            ip5mva_iYRAnnual,
            ip5mva_EFAAnnual,
            ip5mva_Barclay,
            ip7_SandP500Risk,
            ip7_SandPUSRetiree,
            ip7_SandP500Annual,
            ip7_iYRAnnual,
            ip7_EFAAnnual,
            ip7_Barclay,
            ip5_SandP500Risk,
            ip5_SandPUSRetiree,
            ip5_SandP500Annual,
            ip5_iYRAnnual,
            ip5_EFAAnnual,
            ip5_Barclay,
            ia_sp500Minus10PercentageOver250K,
            iaadvisory_sp500Minus10PercentageOver250K,
            ia_sp500OneYear50PercentageOver250K,
            iaadvisory_sp500OneYear50PercentageOver250K,
            ia_sp500OneYear10PercentageOver250K,
            iaadvisory_sp500OneYear10PercentageOver250K,
            ia_sp500SixYear10PercentageOver250K,
            iaadvisory_sp500SixYear10PercentageOver250K,
            ia_eafeOneYear50PercenpageOver250K,
            iaadvisory_eafeOneYear50PercenpageOver250K,
            ia_eafeOneYear10PercenpageOver250K,
            iaadvisory_eafeOneYear10PercenpageOver250K,
            ia_realEstateOneYear50PercentageOver250K,
            iaadvisory_realEstateOneYear50PercentageOver250K,
            ia_realEstateOneYear10PercentageOver250K,
            iaadvisory_realEstateOneYear10PercentageOver250K,
            ia_spdrOneYear50PercentageOver250K,
            iaadvisory_spdrOneYear50PercentageOver250K,
            ia_spdrOneYear10PercentageOver250K,
            iaadvisory_spdrOneYear10PercentageOver250K,
            ia_sp500Minus10Percentage,
            iaadvisory_sp500Minus10Percentage,
            ia_sp500OneYear50Percentage,
            iaadvisory_sp500OneYear50Percentage,
            ia_sp500OneYear10Percentage,
            iaadvisory_sp500OneYear10Percentage,
            ia_sp500SixYear10Percentage,
            iaadvisory_sp500SixYear10Percentage,
            ia_eafeOneYear50Percenpage,
            iaadvisory_eafeOneYear50Percenpage,
            ia_eafeOneYear10Percenpage,
            iaadvisory_eafeOneYear10Percenpage,
            ia_realEstateOneYear50Percentage,
            iaadvisory_realEstateOneYear50Percentage,
            ia_realEstateOneYear10Percentage,
            iaadvisory_realEstateOneYear10Percentage,
            ia_spdrOneYear50Percentage,
            iaadvisory_spdrOneYear50Percentage,
            ia_spdrOneYear10Percentage,
            iaadvisory_spdrOneYear10Percentage,
            formErrors,
            submitted,
            fieldsValid
        } = this.state;
        return (
            <div>
                {AdminAuth.isAdminAuthenticated() && (
                    <div className={classes.logoutButton}>
                        <button onClick={this.logout}>
                            Logout
                        </button>
                    </div>
                )}
                <Tabs>
                    <TabList>
                        <Tab>Fixed Index Annuities</Tab>
                    </TabList>

                    <TabPanel>
                        <div className={classes.AdminRatesPage}>
                            <div className={classes.ratesContainer}>
                                <h5>PARTICIPATION RATES</h5>
                                <div className={classes.row}>
                                    <div className={classes.titleColumn + ' ' + classes.rowTitle}></div>
                                    <div className={classes.column}>IP4</div>
                                    <div className={classes.column}>IP5 MVA</div>
                                    <div className={classes.column}>IP7</div>
                                    <div className={classes.column}>IP5</div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumn + ' ' + classes.rowTitle}>S&P 500 Risk Control</div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip4_SandP500Risk"
                                            value={ip4_SandP500Risk}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip4_SandP500RiskValid &&
                                            <div className={classes.error}>S&P 500 Risk Control {formErrors.ip4_SandP500Risk}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip5mva_SandP500Risk"
                                            value={ip5mva_SandP500Risk}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip5mva_SandP500RiskValid &&
                                            <div className={classes.error}>S&P 500 Risk Control {formErrors.ip5mva_SandP500Risk}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip7_SandP500Risk"
                                            value={ip7_SandP500Risk}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip7_SandP500RiskValid &&
                                            <div className={classes.error}>S&P 500 Risk Control {formErrors.ip7_SandP500Risk}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <label>N/A</label>
                                        {!fieldsValid.ip5_SandP500RiskValid &&
                                        <div className={classes.error}>S&P 500 Risk Control {formErrors.ip5_SandP500Risk}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumn + ' ' + classes.rowTitle}>S&P U.S. Retiree Spending</div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip4_SandPUSRetiree"
                                            value={ip4_SandPUSRetiree}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip4_SandPUSRetireeValid &&
                                            <div className={classes.error}>S&P U.S. Retiree Spending {formErrors.ip4_SandPUSRetiree}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip5mva_SandPUSRetiree"
                                            value={ip5mva_SandPUSRetiree}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip5mva_SandPUSRetireeValid &&
                                            <div className={classes.error}>S&P U.S. Retiree Spending {formErrors.ip5mva_SandPUSRetiree}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip7_SandPUSRetiree"
                                            value={ip7_SandPUSRetiree}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip7_SandPUSRetireeValid &&
                                            <div className={classes.error}>S&P U.S. Retiree Spending {formErrors.ip7_SandPUSRetiree}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <label>N/A</label>
                                        {!fieldsValid.ip5_SandPUSRetireeValid &&
                                        <div className={classes.error}>S&P U.S. Retiree Spending {formErrors.ip5_SandPUSRetiree}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={classes.capsContainer}>
                                <h5>CAPS</h5>
                                <div className={classes.row}>
                                    <div className={classes.titleColumn + ' ' + classes.rowTitle}>S&P 500, Annual point-to-point</div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip4_SandP500Annual"
                                            value={ip4_SandP500Annual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip4_SandP500AnnualValid &&
                                            <div className={classes.error}>S&P 500, Annual point-to-point {formErrors.ip4_SandP500Annual}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip5mva_SandP500Annual"
                                            value={ip5mva_SandP500Annual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip5mva_SandP500AnnualValid &&
                                            <div className={classes.error}>S&P 500, Annual point-to-point {formErrors.ip5mva_SandP500Annual}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip7_SandP500Annual"
                                            value={ip7_SandP500Annual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip7_SandP500AnnualValid &&
                                            <div className={classes.error}>S&P 500, Annual point-to-point {formErrors.ip7_SandP500Annual}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip5_SandP500Annual"
                                            value={ip5_SandP500Annual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip5_SandP500AnnualValid &&
                                        <div className={classes.error}>S&P 500, Annual point-to-point {formErrors.ip5_SandP500Annual}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumn + ' ' + classes.rowTitle}>iYR, Annual point-to-point</div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip4_iYRAnnual"
                                            value={ip4_iYRAnnual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip4_iYRAnnualValid &&
                                            <div className={classes.error}>iYR, Annual point-to-point {formErrors.ip4_iYRAnnual}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip5mva_iYRAnnual"
                                            value={ip5mva_iYRAnnual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip5mva_iYRAnnualValid &&
                                            <div className={classes.error}>iYR, Annual point-to-point {formErrors.ip5mva_iYRAnnual}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip7_iYRAnnual"
                                            value={ip7_iYRAnnual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip7_iYRAnnualValid &&
                                            <div className={classes.error}>iYR, Annual point-to-point {formErrors.ip7_iYRAnnual}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <label>N/A</label>
                                        {!fieldsValid.ip5_iYRAnnualValid &&
                                        <div className={classes.error}>iYR, Annual point-to-point {formErrors.ip5_iYRAnnual}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumn + ' ' + classes.rowTitle}>EFA, Annual point-to-point</div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip4_EFAAnnual"
                                            value={ip4_EFAAnnual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip4_EFAAnnualValid &&
                                            <div className={classes.error}>EFA, Annual point-to-point {formErrors.ip4_EFAAnnual}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip5mva_EFAAnnual"
                                            value={ip5mva_EFAAnnual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip5mva_EFAAnnualValid &&
                                            <div className={classes.error}>EFA, Annual point-to-point {formErrors.ip5mva_EFAAnnual}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip7_EFAAnnual"
                                            value={ip7_EFAAnnual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip7_EFAAnnualValid &&
                                            <div className={classes.error}>EFA, Annual point-to-point {formErrors.ip7_EFAAnnual}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip5_EFAAnnual"
                                            value={ip5_EFAAnnual}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip5_EFAAnnualValid &&
                                        <div className={classes.error}>EFA, Annual point-to-point {formErrors.ip5_EFAAnnual}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        First Trust Barclays Edge Index 1-year point-to-point with cap
                                    </div>
                                    <div className={classes.column}>
                                        N/A
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip5mva_Barclay"
                                            value={ip5mva_Barclay}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip5mva_BarclayValid &&
                                            <div className={classes.error}>First Trust Barclays Edge Index 1-year point-to-point with cap {formErrors.ip5mva_Barclay}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip7_Barclay"
                                            value={ip7_Barclay}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip7_BarclayValid &&
                                            <div className={classes.error}>First Trust Barclays Edge Index 1-year point-to-point with cap {formErrors.ip7_Barclay}</div>
                                        }
                                    </div>
                                    <div className={classes.column}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ip5_Barclay"
                                            value={ip5_Barclay}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ip5_BarclayValid &&
                                            <div className={classes.error}>iFirst Trust Barclays Edge Index 1-year point-to-point with cap {formErrors.ip5_Barclay}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={classes.AdminRatesPage}>
                            <div className={classes.ratesContainer}>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}></div>
                                    <div className={classes.columnRilaTwo}>IA</div>
                                    <div className={classes.columnRilaTwo}>IA Advisory</div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}></div>
                                    <div className={classes.columnRila}>Over $250,000</div>
                                    <div className={classes.columnRila}>$250,000 and Under</div>
                                    <div className={classes.columnRila}>Over $250,000</div>
                                    <div className={classes.columnRila}>$250,000 and Under</div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        S&P 500® 1-Year -10% Floor with Cap
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_sp500Minus10PercentageOver250K"
                                            value={ia_sp500Minus10PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ia_sp500Minus10PercentageOver250KValid &&
                                            <div className={classes.error}>S&P 500® 1-Year -10% Floor with
                                                Cap {formErrors.ia_sp500Minus10PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_sp500Minus10Percentage"
                                            value={ia_sp500Minus10Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ia_sp500Minus10PercentageValid &&
                                        <div className={classes.error}>S&P 500® 1-Year -10% Floor with Cap {formErrors.ia_sp500Minus10Percentage}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_sp500Minus10PercentageOver250K"
                                            value={iaadvisory_sp500Minus10PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_sp500Minus10PercentageOver250KValid &&
                                        <div className={classes.error}>S&P 500® 1-Year -10% Floor with Cap {formErrors.iaadvisory_sp500Minus10PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_sp500Minus10Percentage"
                                            value={iaadvisory_sp500Minus10Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_sp500Minus10PercentageValid &&
                                        <div className={classes.error}>S&P 500® 1-Year -10% Floor with Cap {formErrors.iaadvisory_sp500Minus10Percentage}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        S&P 500® 1-Year 50% Downside Participation Rate with Upside Participation Rate
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_sp500OneYear50PercentageOver250K"
                                            value={ia_sp500OneYear50PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                        {!fieldsValid.ia_sp500OneYear50PercentageOver250KValid &&
                                        <div className={classes.error}>S&P 500® 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.ia_sp500OneYear50PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_sp500OneYear50Percentage"
                                            value={ia_sp500OneYear50Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                        {!fieldsValid.ia_sp500OneYear50PercentageValid &&
                                        <div className={classes.error}>S&P 500® 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.ia_sp500OneYear50Percentage}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_sp500OneYear50PercentageOver250K"
                                            value={iaadvisory_sp500OneYear50PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_sp500OneYear50PercentageOver250KValid &&
                                        <div className={classes.error}>S&P 500® 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.iaadvisory_sp500OneYear50PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_sp500OneYear50Percentage"
                                            value={iaadvisory_sp500OneYear50Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_sp500OneYear50PercentageValid &&
                                        <div className={classes.error}>S&P 500® 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.iaadvisory_sp500OneYear50Percentage}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        S&P 500® 1-Year 10% Buffer with Cap
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_sp500OneYear10PercentageOver250K"
                                            value={ia_sp500OneYear10PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ia_sp500OneYear10PercentageOver250KValid &&
                                        <div className={classes.error}>S&P 500® 1-Year 10% Buffer with Cap {formErrors.ia_sp500OneYear10PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_sp500OneYear10Percentage"
                                            value={ia_sp500OneYear10Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ia_sp500OneYear10PercentageValid &&
                                        <div className={classes.error}>S&P 500® 1-Year 10% Buffer with Cap {formErrors.ia_sp500OneYear10Percentage}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_sp500OneYear10PercentageOver250K"
                                            value={iaadvisory_sp500OneYear10PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_sp500OneYear10PercentageOver250KValid &&
                                        <div className={classes.error}>S&P 500® 1-Year 10% Buffer with Cap {formErrors.iaadvisory_sp500OneYear10PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_sp500OneYear10Percentage"
                                            value={iaadvisory_sp500OneYear10Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_sp500OneYear10PercentageValid &&
                                        <div className={classes.error}>S&P 500® 1-Year 10% Buffer with Cap {formErrors.iaadvisory_sp500OneYear10Percentage}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        S&P 500® 6-Year 10% Buffer with Upside Participation Rate
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_sp500SixYear10PercentageOver250K"
                                            value={ia_sp500SixYear10PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                        {!fieldsValid.ia_sp500SixYear10PercentageOver250KValid &&
                                        <div className={classes.error}>S&P 500® 6-Year 10% Buffer with Upside Participation Rate {formErrors.ia_sp500SixYear10PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_sp500SixYear10Percentage"
                                            value={ia_sp500SixYear10Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                        {!fieldsValid.ia_sp500SixYear10PercentageValid &&
                                        <div className={classes.error}>S&P 500® 6-Year 10% Buffer with Upside Participation Rate {formErrors.ia_sp500SixYear10Percentage}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_sp500SixYear10PercentageOver250K"
                                            value={iaadvisory_sp500SixYear10PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_sp500SixYear10PercentageOver250KValid &&
                                        <div className={classes.error}>S&P 500® 6-Year 10% Buffer with Upside Participation Rate {formErrors.iaadvisory_sp500SixYear10PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_sp500SixYear10Percentage"
                                            value={iaadvisory_sp500SixYear10Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_sp500SixYear10PercentageValid &&
                                        <div className={classes.error}>S&P 500® 6-Year 10% Buffer with Upside Participation Rate {formErrors.iaadvisory_sp500SixYear10Percentage}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        iShares MSCI EAFE ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_eafeOneYear50PercenpageOver250K"
                                            value={ia_eafeOneYear50PercenpageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                        {!fieldsValid.ia_eafeOneYear50PercenpageOver250KValid &&
                                        <div className={classes.error}>iShares MSCI EAFE ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.ia_eafeOneYear50PercenpageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_eafeOneYear50Percenpage"
                                            value={ia_eafeOneYear50Percenpage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                        {!fieldsValid.ia_eafeOneYear50PercenpageValid &&
                                        <div className={classes.error}>iShares MSCI EAFE ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.ia_eafeOneYear50Percenpage}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_eafeOneYear50PercenpageOver250K"
                                            value={iaadvisory_eafeOneYear50PercenpageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_eafeOneYear50PercenpageOver250KValid &&
                                        <div className={classes.error}>iShares MSCI EAFE ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.iaadvisory_eafeOneYear50PercenpageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_eafeOneYear50Percenpage"
                                            value={iaadvisory_eafeOneYear50Percenpage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_eafeOneYear50PercenpageValid &&
                                        <div className={classes.error}>iShares MSCI EAFE ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.iaadvisory_eafeOneYear50Percenpage}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        iShares MSCI EAFE ETF 1-Year 10% Buffer with Cap
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_eafeOneYear10PercenpageOver250K"
                                            value={ia_eafeOneYear10PercenpageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ia_eafeOneYear10PercenpageOver250KValid &&
                                        <div className={classes.error}>iShares MSCI EAFE ETF 1-Year 10% Buffer with Cap {formErrors.ia_eafeOneYear10PercenpageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_eafeOneYear10Percenpage"
                                            value={ia_eafeOneYear10Percenpage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ia_eafeOneYear10PercenpageValid &&
                                        <div className={classes.error}>iShares MSCI EAFE ETF 1-Year 10% Buffer with Cap {formErrors.ia_eafeOneYear10Percenpage}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_eafeOneYear10PercenpageOver250K"
                                            value={iaadvisory_eafeOneYear10PercenpageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_eafeOneYear10PercenpageOver250KValid &&
                                        <div className={classes.error}>iShares MSCI EAFE ETF 1-Year 10% Buffer with Cap {formErrors.iaadvisory_eafeOneYear10PercenpageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_eafeOneYear10Percenpage"
                                            value={iaadvisory_eafeOneYear10Percenpage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_eafeOneYear10PercenpageValid &&
                                        <div className={classes.error}>iShares MSCI EAFE ETF 1-Year 10% Buffer with Cap {formErrors.iaadvisory_eafeOneYear10Percenpage}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        iShares U.S. Real Estate ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_realEstateOneYear50PercentageOver250K"
                                            value={ia_realEstateOneYear50PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                        {!fieldsValid.ia_realEstateOneYear50PercentageOver250KValid &&
                                        <div className={classes.error}>iShares U.S. Real Estate ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.ia_realEstateOneYear50PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_realEstateOneYear50Percentage"
                                            value={ia_realEstateOneYear50Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                        {!fieldsValid.ia_realEstateOneYear50PercentageValid &&
                                        <div className={classes.error}>iShares U.S. Real Estate ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.ia_realEstateOneYear50Percentage}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_realEstateOneYear50PercentageOver250K"
                                            value={iaadvisory_realEstateOneYear50PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_realEstateOneYear50PercentageOver250KValid &&
                                        <div className={classes.error}>iShares U.S. Real Estate ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.iaadvisory_realEstateOneYear50PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_realEstateOneYear50Percentage"
                                            value={iaadvisory_realEstateOneYear50Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_realEstateOneYear50PercentageValid &&
                                        <div className={classes.error}>iShares U.S. Real Estate ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.iaadvisory_realEstateOneYear50Percentage}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        iShares U.S. Real Estate ETF 1-Year 10% Buffer with Cap
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_realEstateOneYear10PercentageOver250K"
                                            value={ia_realEstateOneYear10PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ia_realEstateOneYear10PercentageOver250KValid &&
                                        <div className={classes.error}>iShares U.S. Real Estate ETF 1-Year 10% Buffer with Cap {formErrors.ia_realEstateOneYear10PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_realEstateOneYear10Percentage"
                                            value={ia_realEstateOneYear10Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ia_realEstateOneYear10PercentageValid &&
                                        <div className={classes.error}>iShares U.S. Real Estate ETF 1-Year 10% Buffer with Cap {formErrors.ia_realEstateOneYear10Percentage}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_realEstateOneYear10PercentageOver250K"
                                            value={iaadvisory_realEstateOneYear10PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_realEstateOneYear10PercentageOver250KValid &&
                                        <div className={classes.error}>iShares U.S. Real Estate ETF 1-Year 10% Buffer with Cap {formErrors.iaadvisory_realEstateOneYear10PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_realEstateOneYear10Percentage"
                                            value={iaadvisory_realEstateOneYear10Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_realEstateOneYear10PercentageValid &&
                                        <div className={classes.error}>iShares U.S. Real Estate ETF 1-Year 10% Buffer with Cap {formErrors.iaadvisory_realEstateOneYear10Percentage}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        SPDR Gold Shares ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_spdrOneYear50PercentageOver250K"
                                            value={ia_spdrOneYear50PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                        {!fieldsValid.ia_spdrOneYear50PercentageOver250KValid &&
                                        <div className={classes.error}>SPDR Gold Shares ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.ia_spdrOneYear50PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_spdrOneYear50Percentage"
                                            value={ia_spdrOneYear50Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                        {!fieldsValid.ia_spdrOneYear50PercentageValid &&
                                        <div className={classes.error}>SPDR Gold Shares ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.ia_spdrOneYear50Percentage}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_spdrOneYear50PercentageOver250K"
                                            value={iaadvisory_spdrOneYear50PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_spdrOneYear50PercentageOver250KValid &&
                                        <div className={classes.error}>SPDR Gold Shares ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.iaadvisory_spdrOneYear50PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_spdrOneYear50Percentage"
                                            value={iaadvisory_spdrOneYear50Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_spdrOneYear50PercentageValid &&
                                        <div className={classes.error}>SPDR Gold Shares ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate {formErrors.iaadvisory_spdrOneYear50Percentage}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.titleColumnRila + ' ' + classes.rowTitle}>
                                        SPDR Gold Shares ETF 1-Year 10% Buffer with Cap
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_spdrOneYear10PercentageOver250K"
                                            value={ia_spdrOneYear10PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ia_spdrOneYear10PercentageOver250KValid &&
                                        <div className={classes.error}>SPDR Gold Shares ETF Buffer 1-Year 10% with Cap {formErrors.ia_spdrOneYear10PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="ia_spdrOneYear10Percentage"
                                            value={ia_spdrOneYear10Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.ia_spdrOneYear10PercentageValid &&
                                        <div className={classes.error}>SPDR Gold Shares ETF Buffer 1-Year 10% with Cap {formErrors.ia_spdrOneYear10Percentage}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_spdrOneYear10PercentageOver250K"
                                            value={iaadvisory_spdrOneYear10PercentageOver250K}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_spdrOneYear10PercentageOver250KValid &&
                                        <div className={classes.error}>SPDR Gold Shares ETF Buffer 1-Year 10% with Cap {formErrors.iaadvisory_spdrOneYear10PercentageOver250K}</div>
                                        }
                                    </div>
                                    <div className={classes.columnRila}>
                                        <NumberFormat
                                            className={classes.ratesInput}
                                            name="iaadvisory_spdrOneYear10Percentage"
                                            value={iaadvisory_spdrOneYear10Percentage}
                                            onChange={this.handleChange}
                                            displayType={'input'}
                                            suffix={'%'}
                                            decimalScale={2}
                                        />
                                        {!fieldsValid.iaadvisory_spdrOneYear10PercentageValid &&
                                        <div className={classes.error}>SPDR Gold Shares ETF Buffer 1-Year 10% with Cap {formErrors.iaadvisory_spdrOneYear10Percentage}</div>
                                        }
                                    </div>
                                </div>


                            </div>
                        </div>
                    </TabPanel>
                </Tabs>
                {this.props.adminConfigurationSaved && (
                    <div className={classes.successMessage}>
                        <p>Configuration saved successfuly!</p>
                    </div>
                )}
                <div className={classes.row + ' ' + classes.buttonContainer}>
                    <button className={classes.button + ' ' + classes.CancelButton} onClick={this.cancelClick}>CANCEL</button>
                    <button className={classes.button + ' ' + classes.SaveButton} onClick={this.handleSubmit} disabled={!this.state.formValid}>SAVE</button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        productReducer: state.productReducer,
        adminLoggedIn: state.admin.adminLoggedIn,
        adminConfigurationSaved: state.admin.adminConfigurationSaved
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateMenuState: () => dispatch({ type: actionTypes.ADMIN_PAGE }),
        setAdminPage: () => dispatch({
            type: actionTypes.SET_ADMIN_PAGE
        }),
        getAdminProductsConfiguration: () => dispatch(actionCreators.getAdminProductsConfiguration()),
        updateRates: (
            ip4,
            ip5mva,
            ip7,
            ip5,
            ia,
            iaadvisory
        ) => dispatch(actionCreators.updateRates(
            ip4,
            ip5mva,
            ip7,
            ip5,
            ia,
            iaadvisory
        )),
        adminLogOut: () => dispatch(actionCreators.adminLogOut()),
        adminSuccessfullyLoggedIn: () => dispatch({ type: actionTypes.ADMIN_SUCCESSFULY_LOGGED_IN }),
        adminPageSetSaved: (value) => dispatch({ type: actionTypes.ADMIN_PAGE_SET_SAVED, value: value })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminRatesPage);



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminRatesPage/AdminRatesPage.js